/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { _t } from './i18n';
import { TWithSelectInput, TWithTextInput } from 'app/context/Modal';

export const openConfirmationPopup = (
  modal?: any,
  actionTitle?: string,
  actionModule?: string,
  sumOfActionModule?: string,
  cb?: (message: string, data: any) => any,
  onCancel?: any,
  subCategory?: number,
  hideCancel?: boolean,
  onOkText?: string,
  message?: string,
  withSelectInput?: TWithSelectInput,
  withTextInput?: TWithTextInput,
  smallMessage?: string,
  withCheckboxGroup?: any,
  customStyle?: any,
  onCancelText?: string,
): void => {
  const original_actionTitle = actionTitle;
  if (subCategory) {
    actionTitle = 'trash_category';
  }
  modal?.show({
    message: message
      ? message
      : _t(
          `basic:are_you_sure_you_want_to_${
            actionTitle === 'trash-or-unnecessary' ||
            actionTitle === 'all/trash'
              ? 'hide'
              : actionTitle
          }`,
          {
            module: actionModule,
            sumOfmodule: sumOfActionModule,
          },
        ),
    smallMessage: smallMessage,
    onOk: (selectedItem: any) => {
      modal.hide();
      cb?.(_t(`basic:${original_actionTitle}_success`), selectedItem);
    },
    onCancel: onCancel,
    hideCancel: hideCancel,
    customStyle,
    withCheckboxGroup: withCheckboxGroup
      ? {
          name: withCheckboxGroup?.name,
          options: withCheckboxGroup?.options,
          label: withCheckboxGroup?.label,
          onChange: withCheckboxGroup?.onChange,
        }
      : null,
    onOkText: onOkText,

    withSelectInput: withSelectInput
      ? {
          icon: withSelectInput.icon,
          placeholder: withSelectInput.placeholder,
          options: withSelectInput.options,
          disableOkUntilSelect: withSelectInput.disableOkUntilSelect,
          name: withSelectInput.name,
          isReport: withSelectInput.isReport,
        }
      : null,
    withTextInput: withTextInput
      ? {
          name: withTextInput.name,
          label: withTextInput.label,
          isMandatory: withTextInput.isMandatory,
          placeholder: withTextInput.placeholder,
          onChange: withTextInput.onChange,
        }
      : null,
    onCancelText: onCancelText,
  });
};
export const showUnAuthorizedModal = (message: string, modal: any): unknown =>
  modal?.show({
    isAlternative: true,
    message,
  });
